<template>
  <!-- kategorija dogadjaja u kojoj je mesto vec u naslovu (stocne pijace): lista "vreme + naslov" -->
  <EventsBlock
    :items="items"
    :filter="{ top_event: false, category_name: category_name }"
    :limit="8"
    :year="year"
    :month="month"
    :title="category_name"
    :category="category_name"
    show-all
    layout="feed"
  />
</template>

<script setup>
import EventsBlock from '~/components/widgets/Event/EventsBlock.vue'

defineProps({
  items: { type: Array, default: () => [] },
  year: Number,
  month: String,
  category_name: String,
})
</script>
